module.exports = __webpack_public_path__ + "img/r4.31003061.png";